import React from 'react';
import {Totals} from '../../../../../common/components/Totals/Totals';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {FeeModel} from '../../../../../domain/models/checkout/CartSummary/Fee.model';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../../common/constants';

export const FeeRows = ({fees, groupTitle}: {fees: FeeModel[]; groupTitle: string}) => {
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  const {isCartSummaryUpdating} = useControllerProps().checkoutStore;
  if (!fees.length) {
    return;
  }
  const getFeeValue = (fee: FeeModel) => {
    return isCartSummaryUpdating ? () => <TotalUpdateSkeleton /> : fee.price.formattedAmount;
  };

  if (fees.length === 1) {
    return (
      <Totals.TotalsRow
        dataHook={TotalsSectionDataHooks.AdditionalFeeRow}
        title={fees[0].name}
        value={getFeeValue(fees[0])}
      />
    );
  }
  return (
    <Totals.TotalsSection title={groupTitle} dataHook={TotalsSectionDataHooks.AdditionalFeesSection}>
      {fees.map((fee) => (
        <Totals.TotalsRow
          isSecondary={checkoutUIRevampOrderSummary}
          dataHook={TotalsSectionDataHooks.AdditionalFeeRow}
          key={fee.code}
          title={fee.name}
          value={getFeeValue(fee)}
        />
      ))}
    </Totals.TotalsSection>
  );
};
